/**
 * Submit search form when enter pressed within input field
 * - May remove this depending on requirement
 * @param {Element} target - Search input field
 */
const searchOnKeyup = (target) => {
  if (target) {
    let parentEl = target.closest('.js-form-search')

    if (parentEl) {
      target.addEventListener('keyup', (ev) => {
        if (ev.key === "Key" || ev.which === 13) {
          parentEl.submit()
        }
      })
    }
  } else {
    console.warn('Search on Keyup: No target element given')
  }
}

const initSearch = () => {
  const searchEl = document.querySelector('.js-search')
  if (searchEl) {
    searchOnKeyup(searchEl)
  }
}

export { initSearch }